import React from 'react';
import {
  VStack, HStack, Box, Text,
} from '@gluestack-ui/themed';
import SaveStatusIndicator from '../../../../common/components/SaveStatusIndicator';
import WordCountIndicator from './WordCountIndicator';
import WordCountProgress from './WordCountProgress';

/**
 * Status bar for the editor - displays save status, word count, and progress.
 * This is intentionally a status/observation area, not an action panel.
 */
const BottomPanel = ({
  show = true,
  saveStatus,
  lastSavedAt,
  errorMessage,
  isDirty,
  onRetry,
  wordcount,
  targetWordcount,
  showWordcountDialog,
  wordcountColor,
  readonly,
  isMarkedAsDone,
}) => (show ? (
  <VStack space={0} mt="$2">
    <WordCountProgress wordcount={wordcount} targetWordcount={targetWordcount} wordcountColor={wordcountColor} />
    <HStack alignItems="center" h="$8" py="$2" justifyContent="space-between">
      <Box px="$2" flex={1}>
        {readonly ? (
          <Text size="xs" color="$textSubtle" testID="save-status-readonly">
            Readonly
          </Text>
        ) : (
          <SaveStatusIndicator
            status={saveStatus}
            lastSavedAt={lastSavedAt}
            errorMessage={errorMessage}
            isDirty={isDirty}
            onRetry={onRetry}
            testID="save-status"
          />
        )}
      </Box>
      {isMarkedAsDone ? (
        <Box px="$2">
          <Text size="xs" color="$textSubtle" testID="save-status-marked-as-done">
            Marked as done
          </Text>
        </Box>
      ) : null}
      <Box px="$2">
        <WordCountIndicator
          wordcount={wordcount}
          targetWordcount={targetWordcount}
          showWordcountDialog={showWordcountDialog}
          wordcountColor={wordcountColor}
        />
      </Box>
    </HStack>
  </VStack>
) : null);

export default BottomPanel;
